// Google Maps configuration fetcher
let cachedConfig: {
  apiKey: string;
  enabled: boolean;
} | null = null;

let configPromise: Promise<{apiKey: string; enabled: boolean}> | null = null;

export const getGoogleMapsConfig = async (): Promise<{apiKey: string; enabled: boolean}> => {
  // Return cached config if available
  if (cachedConfig) {
    return cachedConfig;
  }

  // Return existing promise if already fetching
  if (configPromise) {
    return configPromise;
  }

  // Fetch configuration from API
  configPromise = fetch('/api/settings/public/google-maps')
    .then(res => res.json())
    .then(data => {
      cachedConfig = data;
      configPromise = null;
      return data;
    })
    .catch(error => {
      console.error('Failed to fetch Google Maps config:', error);
      configPromise = null;
      // Fall back to environment variable if API fails
      return {
        apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
        enabled: false
      };
    });

  return configPromise;
};

// Clear cache (useful when settings are updated)
export const clearGoogleMapsConfigCache = () => {
  cachedConfig = null;
  configPromise = null;
};